import React, { ReactElement } from 'react';

import styles from './TextContent.module.scss';

interface IProps {
  text: string,
}

export const TextBlock = ({
  text,
}: IProps): ReactElement => {

  return (
    <>
      <section
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </>
  );
};
